export default __webpack_public_path__ + "static/media/scarlatti-f-minor.e3682759.mp3";